// PubSub topic published when feedback is sent from the slideout. The dashboard feedback widget
// loads through an imperative `fetchData` callback rather than a React Query observer, so
// invalidateQueries can't reach it — it subscribes to this event to refetch. Keep producer and
// subscribers on this shared constant so the coupling is explicit — a lone string literal is how
// the publisher was silently orphaned before (PY-13778).
export const FEEDBACK_SENT_EVENT = "sent feedback from slideout";
